<script>
import ListingModel from "@/views/Recruitment/Planning/Components/ListingModel.vue"

export default {
    name: "Evaluations",
    components: {ListingModel},
}
</script>

<template>
    <ListingModel type="EVALUATION"/>
</template>